import React, { useEffect } from "react";
import PropTypes from "prop-types";
import ThumbUpIcon from "@mui/icons-material/ThumbUpAltOutlined";
import ThumbDownIcon from "@mui/icons-material/ThumbDownAltOutlined";
import QuestionPreview from "../QuestionPreview";
import colors from "../../../style/colors";
import useStyles from "./styles";

const AnswerSatisfactionThumbs = (props) => {
  const [thumbsUpColor, setThumbsUpColor] = React.useState(colors.thumbColor);
  const [thumbsDownColor, setThumbsDownColor] = React.useState(
    colors.thumbColor
  );

  const styles = useStyles(props);

  useEffect(() => {
    setColor(props.value);
  }, [props.value]);

  const setColor = (val) => {
    if (val === 5) {
      setThumbsUpColor(props.currentTheme.primaryColor);
      setThumbsDownColor(colors.thumbColor);
    } else if (val === 1) {
      setThumbsUpColor(colors.thumbColor);
      setThumbsDownColor(props.currentTheme.primaryColor);
    }
  };

  const handleChange = (changedValue) => {
    setColor(changedValue);
    props.handleChange(changedValue);
  };

  return (
    <div>
      <fieldset aria-required={props.required}>
        <legend>
          <QuestionPreview
            question={props.question}
            required={props.required}
            helperText={props.helperText}
          />
        </legend>
        <div className={styles.container}>
          <div className={styles.centerContainer}>
            <label>
              <input
                type="radio"
                aria-label="Thumbs up"
                name={props.question}
                tabIndex={0}
                onClick={() => handleChange(5)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleChange(5);
                  }
                }}
                className={styles.radioIcon}
                data-testid="thumb-up-test"
                aria-describedby={props.questionId + "-error"}
              ></input>
              <ThumbUpIcon
                className={styles.icon}
                style={{ color: thumbsUpColor }}
              />
            </label>
            <label>
              <input
                type="radio"
                aria-label="Thumbs down"
                name={props.question}
                tabIndex={0}
                onClick={() => handleChange(1)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleChange(1);
                  }
                }}
                className={styles.radioIcon}
                data-testid="thumb-down-test"
                aria-describedby={props.questionId + "-error"}
              ></input>
              <ThumbDownIcon
                className={styles.icon}
                style={{ color: thumbsDownColor }}
              />
            </label>
          </div>
        </div>
      </fieldset>
    </div>
  );
};

AnswerSatisfactionThumbs.propTypes = {
  question: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
};

AnswerSatisfactionThumbs.defaultProps = {
  handleChange: () => {},
  required: false,
};

export default AnswerSatisfactionThumbs;
